import { Loader } from 'google-maps'

export default {
  init() {
    const loader = new Loader('AIzaSyBUmJUX2m3BrFZuWzIUWQHTUuVGeYJyQzg')

    const office = {
      lat: 13.698965057382464,
      lng: 100.34041117432461,
    }

    loader.load().then(function (google) {
      const map = new google.maps.Map(
        document.getElementById('contact-head-office-map'),
        {
          center: office,
          zoom: 18,
          scrollwheel: false,
        }
      )

      const marker = new google.maps.Marker({
        map,
        draggable: false,
        icon: THAIRUNG.marker,
        position: office,
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open('https://goo.gl/maps/ETYSvZxACupgtRkd7')
      })
    })

    const showroom = {
      lat: 13.792177106187617,
      lng: 100.56062334035137,
    }

    loader.load().then(function (google) {
      const map = new google.maps.Map(
        document.getElementById('contact-showroom-map'),
        {
          center: showroom,
          zoom: 19,
          scrollwheel: false,
        }
      )

      const marker = new google.maps.Marker({
        map,
        draggable: false,
        icon: THAIRUNG.marker,
        position: showroom,
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open('https://g.page/Thairung-Unioncar?share')
      })
    })

    const inputs = document.querySelectorAll('.form-control')
    for (let index = 0; index < inputs.length; index++) {
      const element = inputs[index]
      element.addEventListener(
        'focus',
        (e) => {
          e.target.closest('.form-group').classList.add('is-focus')
        },
        true
      )

      element.addEventListener(
        'blur',
        (e) => {
          if (!e.target.value) {
            e.target.closest('.form-group').classList.remove('is-focus')
          }
        },
        true
      )
    }
  },
  finalize() {},
}
